import { apiSlice } from '../../../api/apiSlice';
import {
    ACKNOWLEDGE_COACHING_CONVERSATION,
    COACHING_CONVERSATION_UPDATE,
    CREATE_CAP_RECORD,
    CREATE_COACHING_CONVERSATION,
    GET_COACHING_CONVERSATION_MODAL,
    REPLY_COACHING_CONVERSATION,
} from '../../../constants';

export const ConversationLogModalSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        createConversation: builder.mutation({
            query: (data: any) => {
                return {
                    url: CREATE_COACHING_CONVERSATION,
                    method: 'POST',
                    body: data,
                };
            },
            invalidatesTags: ['Coaching', 'Activity','coachingInsightHistory'],
        }),
        replyConversation: builder.mutation({
            query: (data: any) => {
                return {
                    url: REPLY_COACHING_CONVERSATION,
                    method: 'PUT',
                    body: data,
                };
            },
            invalidatesTags: ['CoachingConversationModal'],
        }),
        searchConversation: builder.query({
            query: (data: any) => {
                return {
                    url: GET_COACHING_CONVERSATION_MODAL,
                    method: 'GET',
                    params: data,
                };
            },
            providesTags: ['CoachingConversationModal'],
        }),
        acknowledgeConversation: builder.mutation({
            query: (data: any) => {
                return {
                    url: ACKNOWLEDGE_COACHING_CONVERSATION,
                    method: 'PUT',
                    body: data,
                };
            },
            invalidatesTags: ['CoachingConversationModal'],
        }),
        coachingConversation: builder.mutation({
            query: (data: any) => {
                return {
                    url: COACHING_CONVERSATION_UPDATE,
                    method: 'PUT',
                    body: data,
                };
            },
            invalidatesTags: ['CoachingConversationModal'],
        }),
        createCAPRecord: builder.mutation({
            query: (data: any) => {
                return {
                    url: CREATE_CAP_RECORD,
                    method: 'POST',
                    body: data,
                };
            },
            invalidatesTags: ['Coaching', 'Activity','coachingInsightHistory'],
        }),
    }),
});

export const { useCreateConversationMutation, useReplyConversationMutation, useSearchConversationQuery, useAcknowledgeConversationMutation,useCoachingConversationMutation,
    useCreateCAPRecordMutation
 } =
    ConversationLogModalSlice;
